module.exports = __webpack_public_path__ + "img/tree.9d66639c.svg";